<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid"
    class="w-100">
    <BaseTextarea
      :field-class="fieldClass"
      :value="_value"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :rows="rows"
      :max-rows="maxRows"
      :errors="[...errors, ...responseFieldErrors]"
      v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
import BaseTextarea from '@/components/parts/BaseTextarea.vue'
export default {
  name: 'BaseTextareaWithProvider',
  components: {
    BaseTextarea,
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: [Number, String],
      default: 2
    },
    maxRows: {
      type: [Number, String],
      default: null
    },
    responseErrors: {
      type: Object,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: undefined
    },
    fieldClass: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || []
    }
  },
}
</script>

<style lang="scss" scoped>
.base-textarea {
  width: 100%;
  margin-bottom: 0;
}
</style>